const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyMDA1LCJjb25ncmVzc0lkIjoxNDYzLCJkYXRlIjoiMjAyMy0wOS0wN1QwNTo0MjowMy44MDJaIiwiaWF0IjoxNjk0MDY1MzIzfQ.mQ8dIaUD6DcjQUHZJv1iGJDOl-OdYZFpdUPdivJyeIk';
const PLANNER_API_URL = 'https://esaic2024.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyMDA2LCJjb25ncmVzc0lkIjoxNDYzLCJkYXRlIjoiMjAyMy0wOS0wN1QwNTo0MzowMS4xNTZaIiwiaWF0IjoxNjk0MDY1MzgxfQ.Qj9lXJ_4Z4tt5hzM3P7x3KQ0GsnE57OqyrEPI35y2cU';
// const PLANNER_API_URL = 'http://127.0.0.1:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1463;
const SUBMISSION_API_URL = 'https://esaic2024.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{ids}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}